<div class="modal fade" id="modalCore" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modalCore" aria-hidden="true">
  <div class="modal-dialog {{size}}">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col-12 text-right">
            <button type="button" class="btn-close-govco" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>
        </div>

        <div [innerHTML]="modalContentHTML"></div>

        <div class="row mb-3">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-primary-govco" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
